<template>
    <div class="sleep-report-box" v-loading="sleepLoading">
        <div class="sleep-report-title">
            <div>{{ reportSn }}</div>
            <!-- {{ reportDate }} -->
            睡眠报告
            <el-date-picker type="date" v-model="reportDate" placeholder="请选择日期" style="width: 140px;padding-right: 0;"
                value-format="yyyy-MM-dd" :picker-options="pickerOptions" @change="dateChange"></el-date-picker>
        </div>
        <div class="sleep-report-content-box" v-if="true">
            <el-row style="width: 100%;height: 100%">
                <el-col :xs="24" :sm="12" :lg="8" style="height: 100%">
                    <div class="content-box">
                        <div class="sleep-chart-box">
                            <!-- <div class="sleep-chart-title">呼吸心跳频率曲线</div> -->
                            <h4>心率信息</h4>
                            <div style="
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                  ">
                                <img :src="require('../assets/images/sleep/heart_line.png')"
                                    style="height: 40px; margin-right: 10px" />
                                <span>平均心跳频率(次/分):{{
                                        sleepReportContent.heartRate
                                }}</span>
                            </div>
                            <div class="sleep-chart" id="sleepHeartLine"></div>
                        </div>
                        <div class="sleep-chart-box">
                            <h4>呼吸信息</h4>
                            <div style="
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                  ">
                                <img :src="
                                    require('../assets/images/sleep/breather_line.png')
                                " style="height: 40px; margin-right: 10px" />
                                <span>平均呼吸频率(次/分):{{ sleepReportContent.respRate }}</span>
                            </div>

                            <div class="sleep-chart" id="sleepBreatherLine"></div>
                        </div>

                        <div class="sleep-chart-box">
                            <h4>睡眠质量曲线图</h4>
                            <div class="sleep-chart" id="sleepQuality"></div>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :lg="8" style="height: 100%">
                    <div class="content-box">
                        <div class="sleep-chart-box">
                            <!-- <div class="sleep-chart-title">呼吸心跳频率统计</div> -->
                            <h4>心率信息</h4>
                            <div style="
                    height: 40px;
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                  "></div>
                            <div class="sleep-chart" id="sleepHeartBar"></div>
                        </div>
                        <div class="sleep-chart-box">
                            <!-- <div class="sleep-chart-title">呼吸心跳频率统计</div> -->
                            <h4>呼吸信息</h4>
                            <div style="
                    height: 40px;
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                  "></div>
                            <div class="sleep-chart" id="sleepBreatherBar"></div>
                        </div>
                        <div class="sleep-chart-box"></div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :lg="8" style="height: 100%">
                    <div class="content-box">
                        <div class="sleep-analyse-box">
                            <div class="sleep-pie-box">
                                <div class="sleep-pie" id="sleepPie"></div>
                                <div class="sleep-pie-text">
                                    <div style="height: 40px; display: flex; align-items: center">
                                        <img :src="require('../assets/images/sleep/clock.png')"
                                            style="width: 30px; height: 30px" />
                                        <span style="margin: 0 20px 0 10px">在床</span>
                                        <span>{{ sleepReportContent.totalOnBedTime }}</span>
                                    </div>
                                    <div style="height: 40px; display: flex; align-items: center">
                                        <img :src="require('../assets/images/sleep/clock.png')"
                                            style="width: 30px; height: 30px" />
                                        <span style="margin: 0 20px 0 10px">清醒</span>
                                        <span>{{ sleepReportContent.soberTime }}</span>
                                    </div>
                                    <div style="height: 40px; display: flex; align-items: center">
                                        <img :src="require('../assets/images/sleep/clock.png')"
                                            style="width: 30px; height: 30px" />
                                        <span style="margin: 0 20px 0 10px">深睡</span>
                                        <span>{{ sleepReportContent.deepSleepTime }}</span>
                                    </div>
                                    <div style="height: 40px; display: flex; align-items: center">
                                        <img :src="require('../assets/images/sleep/clock.png')"
                                            style="width: 30px; height: 30px" />
                                        <span style="margin: 0 20px 0 10px">浅睡</span>
                                        <span>{{ sleepReportContent.lightSleepTime }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="bed-sleep-wake-box">
                                <div class="bed-sleep-wake">
                                    <img :src="require('../assets/images/sleep/go_bed.png')"
                                        style="width: 60px; height: 60px" />
                                    <div style="margin: 5px 0">上床时间</div>
                                    <div>{{ sleepReportContent.goToBedTime }}</div>
                                </div>
                                <div class="bed-sleep-wake">
                                    <img :src="require('../assets/images/sleep/sleep.png')"
                                        style="width: 60px; height: 60px" />
                                    <div style="margin: 5px 0">入睡时间</div>
                                    <div>{{ sleepReportContent.asleepTime }}</div>
                                </div>
                                <div class="bed-sleep-wake" v-if="sleepReportContent.ifGetUp">
                                    <img :src="require('../assets/images/sleep/reter.png')"
                                        style="width: 60px; height: 60px" />
                                    <div style="margin: 5px 0">醒来时间</div>
                                    <div>{{ sleepReportContent.wakeTime }}</div>
                                </div>
                                <div class="bed-sleep-wake">
                                    <img :src="require('../assets/images/sleep/get_up.png')"
                                        style="width: 60px; height: 60px" />
                                    <div style="margin: 5px 0">起床时间</div>
                                    <div>
                                        {{
                                                !sleepReportContent.ifGetUp
                                                    ? sleepReportContent.upBedRemind
                                                    : sleepReportContent.leaveBedTime
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div style="flex: 1; overflow-y: auto">
                                <div class="leave-bed-times-box">
                                    <div class="leave-bed-times">
                                        <img :src="require('../assets/images/sleep/alarm.png')"
                                            style="width: 30px; height: 30px" />
                                        <span style="margin: 0 30px 0 10px">体动次数</span>
                                        <div style="flex: 1; text-align: right; margin-right: 20px">
                                            {{ sleepReportContent.bodyMovementNumbers }}
                                        </div>
                                    </div>
                                    <div class="leave-bed-times">
                                        <img :src="require('../assets/images/sleep/alarm.png')"
                                            style="width: 30px; height: 30px" />
                                        <span style="margin: 0 30px 0 10px">平均体动次数/小时</span>
                                        <div style="flex: 1; text-align: right; margin-right: 20px">
                                            {{ sleepReportContent.bodyMovementNumbersPerHour }}
                                        </div>
                                    </div>
                                </div>
                                <div class="leave-bed-times-box">
                                    <div class="leave-bed-times">
                                        <img :src="require('../assets/images/sleep/alarm.png')"
                                            style="width: 30px; height: 30px" />
                                        <span style="margin: 0 30px 0 10px">离床次数</span>
                                        <div style="flex: 1; text-align: right; margin-right: 20px">
                                            {{ sleepReportContent.leaveBedNumbers }}
                                        </div>
                                    </div>
                                    <div class="leave-bed-times">
                                        <img :src="require('../assets/images/sleep/alarm.png')"
                                            style="width: 30px; height: 30px" />
                                        <span style="margin: 0 30px 0 10px">离床总时间(min)</span>
                                        <div style="flex: 1; text-align: right; margin-right: 20px">
                                            {{ sleepReportContent.leaveTotalTime }}
                                        </div>
                                    </div>
                                </div>

                                <div class="leave-bed-times-box" v-for="(item, index) in sleepHisBedTimeList"
                                    :key="index">
                                    <div class="leave-bed-times">
                                        <img :src="require('../assets/images/sleep/alarm.png')"
                                            style="width: 30px; height: 30px" />
                                        <span style="margin: 0 30px 0 10px">离床时刻{{ index + 1 }}</span>
                                        <div style="flex: 1; text-align: right; margin-right: 20px">
                                            {{ item.start }}
                                        </div>
                                    </div>
                                    <div class="leave-bed-times">
                                        <img :src="require('../assets/images/sleep/alarm.png')"
                                            style="width: 30px; height: 30px" />
                                        <span style="margin: 0 30px 0 10px">回床时刻{{ index + 1 }}</span>
                                        <div style="flex: 1; text-align: right; margin-right: 20px">
                                            {{ item.end }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
// timeType  1,2,3
// 1，昨天，2，前天，3，过去七天
import pako from "pako";
import { Base64 } from "js-base64";
import {
    getBuilding,
    getFloor,
    getRoom,
    getBed,
    getDevice,
    queryHistoryData,
    querySleepData,
    query50Data,
    queryHisEvent,
    pushReport,
    downReport,
    sleepReport
} from "../api/device";
import utils from "../utils/utils";

import * as echarts from "echarts/core";
import {
    TooltipComponent,
    GridComponent,
    DataZoomComponent,
    MarkAreaComponent,
    VisualMapComponent,
    MarkLineComponent,
    LegendComponent,
} from "echarts/components";
import { LineChart, BarChart, PieChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
import { Loading } from "element-ui";

echarts.use([
    TooltipComponent,
    GridComponent,
    DataZoomComponent,
    MarkAreaComponent,
    VisualMapComponent,
    LineChart,
    BarChart,
    CanvasRenderer,
    MarkLineComponent,
    LegendComponent,
    PieChart,
]);

let heartLine;
let breatherLine;
let qualityLine;
let heartBar;
let breatherBar;
let sleepPie;

export default {
    name: "RealTime",
    data() {
        return {
            reportSn: '',
            reportDate: '',
            pageHeight: 0,
            isManage: false,
            userRooms: [],
            userFloors: [],
            userBuildings: [],
            tower: "",
            floor: "",
            room: "",
            bed: "",
            towers: [],
            floors: [],
            rooms: [],
            beds: [],
            allDevices: [],
            monitorList: [],

            historyList: [],
            pushDate: null,
            pickerOptions: {
                disabledDate: (time) => {
                    return (
                        time.getTime() >=
                        new Date(new Date().setHours(0, 0, 0, 0)).getTime() ||
                        time.getTime() <
                        new Date(
                            new Date(
                                new Date().setMonth(new Date().getMonth() - 2)
                            ).setHours(0, 0, 0, 0)
                        ).getTime()
                    );
                },
            },

            eventPickerOptions: {
                disabledDate: (time) => {
                    return (
                        time.getTime() >
                        new Date(new Date().setHours(0, 0, 0, 0)).getTime() ||
                        time.getTime() <
                        new Date(
                            new Date(
                                new Date().setMonth(new Date().getMonth() - 1)
                            ).setHours(0, 0, 0, 0)
                        ).getTime()
                    );
                },
            },

            isMask: false,
            successImg: require("../assets/images/main/success.svg"),
            selectTag: require("../assets/images/main/selectTag.svg"),
            closeImg: require("../assets/images/system/close.svg"),

            prevImg: require("../assets/images/main/prev.svg"),
            nextImg: require("../assets/images/main/next.svg"),
            ellipsisImg: require("../assets/images/main/ellipsis.svg"),
            pages: [
                {
                    num: 1,
                    isActive: true,
                },
                {
                    num: 2,
                    isActive: false,
                },
                {
                    num: 3,
                    isActive: false,
                },
                {
                    num: 4,
                    isActive: false,
                },
                {
                    num: 5,
                    isActive: false,
                },
            ],
            activeIndex: 0,
            reportData: {},
            reportLoading: false,
            isReport: false,
            isSuccess: false,
            exportLoading: false,
            isSleepMask: false,
            sleepLoading: false,
            sleepDate: "",
            sleepRoom: "",
            sleepLocation: "",
            sleepMonitor: "",
            sleepReportContent: {},
            sleepHisBedTimeList: [],
            hisDialog: false,
            hisEvents: [],
            hisTotal: 0,
            currentPage: 1,
            currentData: {},
            eventType: "",
            eventTypes: [
                {
                    label: "心率过高",
                    value: 1,
                },
                {
                    label: "心率过低",
                    value: 2,
                },
                {
                    label: "心率异常",
                    value: 3,
                },
                {
                    label: "呼吸过高",
                    value: 4,
                },
                {
                    label: "呼吸过低",
                    value: 5,
                },
                {
                    label: "呼吸异常",
                    value: 6,
                },
                {
                    label: "离床未归",
                    value: 7,
                },
                {
                    label: "长时间未体动",
                    value: 8,
                },
                {
                    label: "离床事件",
                    value: 9,
                },
                {
                    label: "上床事件",
                    value: 10,
                },
                {
                    label: "体动事件",
                    value: 11,
                },
                {
                    label: "起身事件",
                    value: 12,
                },
            ],
            selectDate: "",
            hisLoading: false,
            deviceTotal: 0,
            currPage: 1,
            pageSize: 15,
            searchSn: "",
            pushSn: ''
        };
    },
    created() {
        this.reportSn = this.getQueryString('sn')
        this.reportDate = this.getQueryString('date')
        this.showSleepReport()
    },
    mounted() {
        window.addEventListener("resize", this.chartResize, false);
    },
    computed: {},
    methods: {
        dateChange(e){
            this.showSleepReport()
        },
        getQueryString(name) {
            let index = window.location.href.indexOf('?');
            let value = window.location.href.slice(index + 1, window.location.href.length)
            let arr = value.split('&');
            let list = [];
            let content = undefined
            if (arr.length > 0) {
                arr.forEach(item => {
                    list.push(item.split('='))
                })
            }

            if (list.length > 0) {
                list.forEach(item => {
                    if (item[0] == name) {
                        content = item[1]
                    }
                })
            }

            return content
        },
        initPageHeight() {
            this.pageHeight = window.innerHeight - 80;

            echarts.getInstanceByDom(document.getElementById("sleepBreatherLine")) &&
                echarts
                    .getInstanceByDom(document.getElementById("sleepBreatherLine"))
                    .resize();
            echarts.getInstanceByDom(document.getElementById("sleepHeartLine")) &&
                echarts
                    .getInstanceByDom(document.getElementById("sleepHeartLine"))
                    .resize();
            echarts.getInstanceByDom(document.getElementById("sleepBreatherBar")) &&
                echarts
                    .getInstanceByDom(document.getElementById("sleepBreatherBar"))
                    .resize();
            echarts.getInstanceByDom(document.getElementById("sleepHeartBar")) &&
                echarts
                    .getInstanceByDom(document.getElementById("sleepHeartBar"))
                    .resize();
            echarts.getInstanceByDom(document.getElementById("sleepQuality")) &&
                echarts
                    .getInstanceByDom(document.getElementById("sleepQuality"))
                    .resize();
            echarts.getInstanceByDom(document.getElementById("sleepPie")) &&
                echarts.getInstanceByDom(document.getElementById("sleepPie")).resize();
        },

        // 时间处理
        formatTime(time) {
            let hour = parseInt(time / 3600);
            let min = parseInt((time % 3600) / 60);
            let sec = (time % 3600) % 60;

            if (hour < 10) {
                hour = "0" + hour;
            }
            if (min < 10) {
                min = "0" + min;
            }
            if (sec < 10) {
                sec = "0" + sec;
            }

            return `${hour}:${min}:${sec}`;
        },

        initHeartLine(dom, yName, data, isShowX, markArea, visualMap) {
            console.log(data);
            var chartDom = document.getElementById(dom);
            heartLine = echarts.init(chartDom);
            var option;

            option = {
                xAxis: {
                    name: "时间",
                    type: "category",
                    data: data.x,
                    axisLabel: {
                        show: isShowX ? isShowX : false,
                    },
                },
                grid: {
                    bottom: 15,
                    top: 30,
                    containLabel: true,
                },
                dataZoom: [
                    {
                        type: "inside",
                        minValueSpan: 10,
                    },
                ],
                yAxis: {
                    name: yName,
                    type: "value",
                },
                tooltip: {
                    trigger: "axis",
                },
                series: [
                    {
                        data: data.y,
                        type: "line",
                        markArea: markArea ? markArea : {},
                        symbol: "none",
                        // areaStyle: {
                        //   color: '#9eccab'
                        // }
                    },
                ],
            };

            if (visualMap) {
                option.visualMap = visualMap;
            }

            heartLine.setOption(option);
        },

        initBreatherLine(dom, yName, data, isShowX, markArea, visualMap) {
            console.log(data);
            var chartDom = document.getElementById(dom);
            breatherLine = echarts.init(chartDom);
            var option;

            option = {
                xAxis: {
                    name: "时间",
                    type: "category",
                    data: data.x,
                    axisLabel: {
                        show: isShowX ? isShowX : false,
                    },
                },
                grid: {
                    bottom: 15,
                    top: 30,
                    containLabel: true,
                },
                dataZoom: [
                    {
                        type: "inside",
                        minValueSpan: 10,
                    },
                ],
                yAxis: {
                    name: yName,
                    type: "value",
                },
                tooltip: {
                    trigger: "axis",
                },
                series: [
                    {
                        data: data.y,
                        type: "line",
                        markArea: markArea ? markArea : {},
                        symbol: "none",
                        // areaStyle: {
                        //   color: '#9eccab'
                        // }
                    },
                ],
            };

            if (visualMap) {
                option.visualMap = visualMap;
            }

            breatherLine.setOption(option);
        },

        initQuaLine(dom, yName, data) {
            var chartDom = document.getElementById(dom);
            qualityLine = echarts.init(chartDom);
            var option;

            option = {
                xAxis: {
                    name: "",
                    type: "category",
                    data: data.x,
                },
                grid: {
                    bottom: "15%",
                    top: "20%",
                    right: "15%",
                },
                dataZoom: [
                    {
                        type: "inside",
                        minValueSpan: 10,
                    },
                ],
                yAxis: {
                    name: yName,
                    type: "value",
                    min: -1,
                    max: 1,
                },
                tooltip: {
                    trigger: "axis",
                },
                series: [
                    {
                        data: data.y,
                        type: "line",
                        symbol: "none",

                        markLine: {
                            data: [
                                {
                                    yAxis: 0.4,
                                    lineStyle: {
                                        color: "red",
                                        type: "solid",
                                    },
                                    label: {
                                        position: "end",
                                        formatter: "深睡门限0.4",
                                    },
                                },
                                {
                                    label: {
                                        position: "end",
                                        formatter: "浅睡门限0.8",
                                    },
                                    yAxis: 0.8,
                                    lineStyle: {
                                        color: "#f3d07a",
                                        type: "solid",
                                    },
                                },
                            ],
                        },
                        // areaStyle: {
                        //   color: '#9eccab'
                        // }
                    },
                ],
            };

            qualityLine.setOption(option);
        },

        initHeartBar(dom, xName, data, range) {
            if (!range) {
                range = {
                    start: 0,
                    end: 100,
                };
            }
            var chartDom = document.getElementById(dom);
            heartBar = echarts.init(chartDom);
            var option;

            option = {
                xAxis: {
                    name: xName,
                    nameGap: 2,
                    type: "category",
                    data: data.x,
                    nameTextStyle: {
                        rich: {
                            a: {},
                        },
                    },
                },
                grid: {
                    bottom: 15,
                    top: 30,
                    containLabel: true,
                },
                dataZoom: [
                    {
                        type: "inside",
                        startValue: range.start,
                        endValue: range.end,
                        minValueSpan: 10,
                    },
                ],
                yAxis: {
                    name: "出现次数",
                    type: "value",
                },
                tooltip: {
                    trigger: "axis",
                },
                series: [
                    {
                        data: data.y,
                        type: "bar",
                    },
                ],
            };

            heartBar.setOption(option);
        },

        initBreatherBar(dom, xName, data, range) {
            if (!range) {
                range = {
                    start: 0,
                    end: 100,
                };
            }
            var chartDom = document.getElementById(dom);
            breatherBar = echarts.init(chartDom);
            var option;

            option = {
                xAxis: {
                    name: xName,
                    nameGap: 2,
                    type: "category",
                    data: data.x,
                    nameTextStyle: {
                        rich: {
                            a: {},
                        },
                    },
                },
                grid: {
                    bottom: 15,
                    top: 30,
                    containLabel: true,
                },
                dataZoom: [
                    {
                        type: "inside",
                        startValue: range.start,
                        endValue: range.end,
                        minValueSpan: 10,
                    },
                ],
                yAxis: {
                    name: "出现次数",
                    type: "value",
                },
                tooltip: {
                    trigger: "axis",
                },
                series: [
                    {
                        data: data.y,
                        type: "bar",
                    },
                ],
            };

            breatherBar.setOption(option);
        },

        initPie(dom, data) {
            var chartDom = document.getElementById(dom);
            sleepPie = echarts.init(chartDom);
            var option;

            option = {
                tooltip: {
                    trigger: "item",
                },
                // legend: {
                //   orient: "vertical",
                //   top: "middle",
                //   left: "right"
                // },
                grid: {
                    top: 0,
                    bottom: 0,
                },
                series: [
                    {
                        name: "睡眠百分比",
                        type: "pie",
                        radius: "50%",
                        data: data,
                    },
                ],
            };

            sleepPie.setOption(option);
        },

        // 睡眠报告
        showSleepReport() {
            this.sleepLoading = true;

            sleepReport({
                reportDate: this.reportDate,
                radarSn: this.reportSn,
            }).then((res) => {
                this.sleepLoading = false;

                console.log("查询睡眠报告", res);
                res.data.medicineSleepQuality.respRate = parseFloat(
                    res.data.medicineSleepQuality.breathingRate
                ).toFixed(1);
                res.data.medicineSleepQuality.heartRate = parseFloat(
                    res.data.medicineSleepQuality.heartbeatRate
                ).toFixed(1);
                res.data.medicineSleepQuality.awakeningRate = parseFloat(
                    res.data.medicineSleepQuality.awakeningRate
                ).toFixed(1);
                res.data.medicineSleepQuality.lightSleepRate = parseFloat(
                    res.data.medicineSleepQuality.lightSleepRate
                ).toFixed(1);
                res.data.medicineSleepQuality.deepSleepRate = parseFloat(
                    res.data.medicineSleepQuality.deepSleepRate
                ).toFixed(1);
                res.data.medicineSleepQuality.bodyMovementNumbersPerHour =
                    parseFloat(
                        res.data.medicineSleepQuality.bodyMovementNumbersPerHour
                    ).toFixed(1);
                this.sleepReportContent = res.data.medicineSleepQuality;
                this.sleepReportContent.goToBedTime = utils
                    .formatTime(new Date(this.sleepReportContent.goToBedTime))
                    .slice(10, 16);
                this.sleepReportContent.asleepTime = utils
                    .formatTime(new Date(this.sleepReportContent.asleepTime))
                    .slice(10, 16);
                this.sleepReportContent.wakeTime = this.sleepReportContent.wakeTime
                    ? utils
                        .formatTime(new Date(this.sleepReportContent.wakeTime))
                        .slice(10, 16)
                    : this.sleepReportContent.wakeTime;
                this.sleepReportContent.leaveBedTime = this.sleepReportContent
                    .leaveBedTime
                    ? utils
                        .formatTime(new Date(this.sleepReportContent.leaveBedTime))
                        .slice(10, 16)
                    : this.sleepReportContent.leaveBedTime;

                this.sleepReportContent.totalOnBedTime = `${parseInt(
                    this.sleepReportContent.totalOnBedTime / 3600
                )}时${parseInt(this.sleepReportContent.totalOnBedTime / 60) % 60
                    }分`;
                // this.sleepReportContent.leaveTotalTime = `${parseInt(
                //   this.sleepReportContent.leaveTotalTime / 3600
                // )}时${
                //   parseInt(this.sleepReportContent.leaveTotalTime / 60) % 60
                // }分`;
                this.sleepReportContent.leaveTotalTime = `${parseInt(this.sleepReportContent.leaveTotalTime) / 60
                    }分`;
                this.sleepReportContent.soberTime = `${parseInt(
                    this.sleepReportContent.soberTime / 3600
                )}时${parseInt(this.sleepReportContent.soberTime / 60) % 60}分`;
                this.sleepReportContent.deepSleepTime = `${parseInt(
                    this.sleepReportContent.deepSleepTime / 3600
                )}时${parseInt(this.sleepReportContent.deepSleepTime / 60) % 60}分`;
                this.sleepReportContent.lightSleepTime = `${parseInt(
                    this.sleepReportContent.lightSleepTime / 3600
                )}时${parseInt(this.sleepReportContent.lightSleepTime / 60) % 60
                    }分`;

                this.sleepHisBedTimeList =
                    res.data.medicineSleepQuality.leaveBedIntervals;
                if (this.sleepHisBedTimeList.length > 0) {
                    this.sleepHisBedTimeList.forEach((item) => {
                        item.start = utils
                            .formatTime(new Date(item.startTime))
                            .slice(10, 16);
                        item.end = utils
                            .formatTime(new Date(item.endTime))
                            .slice(10, 16);
                    });
                }
                let date = res.data.medicineSleepQuality.reportDate.split("-");
                this.sleepDate = `${date[0]}年${date[1]}月${date[2]}日`;

                let pieData = [
                    {
                        value: this.sleepReportContent.lightSleepRate,
                        name: "浅睡眠",
                    },
                    {
                        value: this.sleepReportContent.deepSleepRate,
                        name: "深睡眠",
                    },
                    {
                        value: this.sleepReportContent.awakeningRate,
                        name: "觉醒",
                    },
                ];
                this.initPie("sleepPie", pieData);

                let x = [];
                let y1 = [];
                let y2 = [];
                if (res.data.breathAndHeartInfoList.length > 0) {
                    res.data.breathAndHeartInfoList.forEach((item) => {
                        x.push(`${item.hour}时${item.minute}分`);
                        y1.push(item.respRate);
                        y2.push(item.heartRate);
                    });
                }

                this.initBreatherLine(
                    "sleepBreatherLine",
                    "呼吸频率(次/分钟)",
                    { x: x, y: y1 },
                    true
                );

                let markArea = {
                    label: {
                        position: "right",
                    },
                    data: [
                        [
                            {
                                name: "偏低",
                                yAxis: 0,
                                itemStyle: {
                                    color: "rgba(0,0,0,0.2)",
                                },
                            },
                            {
                                yAxis: 60,
                            },
                        ],
                        [
                            {
                                name: "正常",
                                yAxis: 60,
                            },
                            {
                                yAxis: 100,
                            },
                        ],
                        [
                            {
                                name: "偏高",
                                yAxis: 100,
                                itemStyle: {
                                    color: "rgba(255,255,255,0)",
                                },
                            },
                            {
                                yAxis: 200,
                            },
                        ],
                    ],
                    silent: true,
                };

                let visualMap = {
                    type: "piecewise",
                    pieces: [
                        { gt: 100, lte: 200, color: "yellow" },
                        { gt: 60, lte: 100, color: "blue" },
                        { gt: 0, lte: 60, color: "red" },
                    ],
                    show: false,
                };

                this.initHeartLine(
                    "sleepHeartLine",
                    "心跳频率(次/分钟)",
                    { x: x, y: y2 },
                    true,
                    markArea,
                    visualMap
                );

                let [qx, qy] = [[], []];

                if (res.data.sleepQualityInfo.length > 0) {
                    res.data.sleepQualityInfo.forEach((item, index) => {
                        qy.push(item.saveSleepQualityData);
                        qx.push(item.showTime);
                    });
                }

                this.initQuaLine(
                    "sleepQuality",
                    "睡眠质量指数",
                    { x: qx, y: qy },
                    true
                );

                let heartBarData = {
                    x: [],
                    y: [],
                };
                for (let i = 0; i < res.data.heartList.length; i++) {
                    heartBarData.x.push(i + 1);
                }
                heartBarData.y = res.data.heartList;
                this.initHeartBar(
                    "sleepHeartBar",
                    "{a|心跳频率\n(次/分钟)}",
                    heartBarData,
                    {
                        start: "40",
                        end: "120",
                    }
                );

                let breatherBarData = {
                    x: [],
                    y: [],
                };
                for (let i = 0; i < res.data.breatheList.length; i++) {
                    breatherBarData.x.push(i + 1);
                }
                breatherBarData.y = res.data.breatheList;
                this.initBreatherBar(
                    "sleepBreatherBar",
                    "{a|呼吸频率\n(次/分钟)}",
                    breatherBarData,
                    { start: "1", end: "30" }
                );
            }).catch((err) => {
                this.sleepLoading = false;
            });
        },

        chartResize() {
            heartLine && heartLine.resize();
            breatherLine && breatherLine.resize();
            qualityLine && qualityLine.resize();
            heartBar && heartBar.resize();
            breatherBar && breatherBar.resize();
            sleepPie && sleepPie.resize();
        },

        chartDispose() {
            heartLine && heartLine.dispose();
            breatherLine && breatherLine.dispose();
            qualityLine && qualityLine.dispose();
            heartBar && heartBar.dispose();
            breatherBar && breatherBar.dispose();
            sleepPie && sleepPie.dispose();
        }
    },
    beforeDestroy() {
        this.chartDispose()
        window.removeEventListener("resize", this.chartResize, false);
    },
    watch: {},
};
</script>

<style scoped lang='less'>
.sleep-report-box {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: #e5faff;

    .sleep-report-title {
        width: 100%;
        height: 60px;
        background: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        box-sizing: border-box;
        padding: 0 10px;
    }

    .sleep-report-content-box {
        width: 100%;
        flex: 1;
        height: 0;
        overflow-y: auto;
        overflow-x: hidden;
    }
}
</style>
<style>
.report-title {
    width: 100%;
    height: 70px;
    line-height: 70px;
    font-size: 25px;
    position: relative;
    text-align: center;
}

.report-info-box {
    height: 30px;
    padding-left: 25px;
    display: flex;
}

.report-info {
    width: 150px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    margin-right: 20px;
}

.report-chart-box {
    flex: 1;
    padding: 30px 50px 0;
    display: flex;
    justify-content: space-between;
}

.report-chart-box-last {
    margin-bottom: 30px;
}

.report-chart {
    flex: 1;
    height: 100%;
    margin-right: 30px;
    background: #fff;
    border-radius: 8px;
}

.report-chart:last-child {
    margin-right: 0;
}

/* 睡眠报告 */
.sleep-report-title-box {
    width: 100%;
    height: 70px;
    background: #fff;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
}

.sleep-report-title {
    /* margin-top: 72px; */
    font-size: 25px;
}

.sleep-room-info {
    margin: 20px 5%;
    display: flex;
    justify-content: space-between;
}

.sleep-room-info div {
    font-size: 18px;
    /* margin-right: 163px; */
}

.sleep-chart-title {
    font-size: 14px;
    /* margin: 0 0 40px 25px; */
}

.sleep-report-content {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.sleep-report-content::-webkit-scrollbar {
    display: none;
}

.content-box {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 10px;
    box-sizing: border-box;
}

.content-box:nth-child(2) {
    margin: 0 10px;
}

.sleep-chart-box {
    /* margin: 0 100px 50px; */
    /* display: flex; */
    /* height: 250px; */
    flex: 1;
    display: flex;
    flex-direction: column;
}

.sleep-chart {
    flex: 1;
    /* height: 250px; */
    /* background: #fff; */
    border-radius: 12px;
}

h4 {
    margin: 10px 0;
}

.sleep-analyse-box {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.sleep-pie-box {
    width: 100%;
    height: 250px;
    display: flex;
}

.sleep-pie {
    width: 60%;
    max-width: 60%;
    height: 250px;
}

.sleep-pie-text {
    width: 40%;
    min-width: 40%;
    height: 250px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.bed-sleep-wake-box {
    display: flex;
    margin-bottom: 20px;
}

.bed-sleep-wake {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.leave-bed-times-box {
    display: flex;
    padding: 0 25px;
    box-sizing: border-box;
    margin: 5px 0;
    font-size: 14px;
}

.leave-bed-times {
    flex: 1;
    display: flex;
    height: 40px;
    align-items: center;
    /* background: #e4f3e4; */
}

.sleep-bottom {
    font-size: 12px;
    text-align: center;
    margin: 10px 0;
}

.sleep-analyse {
    font-size: 14px;
    display: flex;
    align-items: center;
    margin-bottom: 40px;
}

.sleep-analyse img {
    width: 25px;
    height: 25px;
    margin-right: 10px;
}

.sleep-analyse-content {
    /* margin: 0 140px; */
    font-size: 16px;
    display: flex;
}

.sleep-analyse-content div {
    height: 50px;
    flex: 1;
    display: flex;
    align-items: center;
    background: #fff;
}

.sleep-analyse-content img {
    width: 28px;
    height: 28px;
    margin: 0 20px;
}

.sleep-analyse-content-img {
    display: block;
    width: 28px;
    height: 28px;
    margin: 0 20px;
}

.sleep-analyse-content-grey div {
    background: #efefef;
}

.sleep-analyse-content-left {
    margin-right: 60px;
}

.sleep-analyse-content-radius {
    flex: 1;
    overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/views/report.vue